import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AuthContext } from "../../../Contexts/AuthContext/AuthProvider";
import { RotatingSquare } from "react-loader-spinner";
const ForexEdit = () => {
  const { authUser } = useContext(AuthContext);
  const [errorMessage, setErrorMessage] = useState([]);
  const [updateData, setUpdateData] = useState([]);
  const refSubmitDis = useRef();

  const { id } = useParams();
  const [image, setImage] = useState(null);

  const handleImage = (e) => {
    setImage(e.target.files[0]);
  };
  const handleSubmitData = (event) => {
    try {
      event.preventDefault();
      refSubmitDis.current.setAttribute("disabled", true);
      setErrorMessage("");
      const formData = new FormData(event.currentTarget);
      const InpuData = Object.fromEntries(formData);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      const userData = { ...InpuData, image: image };
      axios
        .put(
          `https://api.wlfmobile.com/api/admin/forex/update/${id}`,
          userData,
          config
        )
        .then((response) => {
          event.target.reset();
          toast.success(`${response?.data.message}`, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setUpdateData(response?.data);
          refSubmitDis.current.removeAttribute("disabled");
        })
        .catch((error) => {
          refSubmitDis.current.removeAttribute("disabled");
          if (error?.response?.data.message) {
            toast.error(`${error?.response?.data.message}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
          console.log(error);
          if (error?.response?.data?.errors) {
            setErrorMessage(error?.response?.data?.errors);
          } else {
            setErrorMessage(error?.response?.data);
          }
        });
    } catch (error) {
      
      refSubmitDis.current.removeAttribute("disabled");
      if (error?.response?.data?.errors) {
        setErrorMessage(error?.response?.data?.errors);
      } else {
        setErrorMessage(error?.response?.data);
      }
    }
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://api.wlfmobile.com/api/admin/forex/edit/${id}`, {
      method: "GET",
    })
      .then((res) => res.json())
      .then((data) => {
        setData(data?.data);
        setLoading(false);
      });
  }, [updateData]);

  if (!authUser?.crypto_currency) {
    if (authUser?.crypto_currency === undefined) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <h1>unauthorized</h1>
        </>
      );
    }
  } else {
    if (loading) {
      return (
        <>
          <div className="loader-css">
            <RotatingSquare
              visible={true}
              height="100"
              width="100"
              color="#4fa94d"
              ariaLabel="rotating-square-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        </>
      );
    }
    return (
      <>
        <div className="d-flex mb-30 flex-wrap gap-3 justify-content-between align-items-center">
          <h6 className="page-title">Update Forex</h6>
          <div className="d-flex flex-wrap justify-content-end gap-2 align-items-center breadcrumb-plugins">
            <Link
              to="/admin/forex/list"
              className="btn btn-sm btn-outline-primary"
            >
              <i className="la la-undo"></i> Back
            </Link>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <form onSubmit={handleSubmitData}>
                <div className="card-body">
                  <div className="payment-method-item">
                    <div className="payment-method-body">
                      <div className="row mt-4">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label for="name" className="required">
                              Name
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                id="name"
                                defaultValue={data?.name}
                              />
                            </div>
                            {errorMessage?.name && (
                              <span className="text-danger pt-2">
                                {errorMessage?.name?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="base_currency" className="required">
                              Base Currency
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="base_currency"
                                id="base_currency"
                                defaultValue={data?.base_currency}
                              />
                            </div>
                            {errorMessage?.base_currency && (
                              <span className="text-danger pt-2">
                                {errorMessage?.base_currency?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label
                              htmlFor="quote_currency"
                              className="required"
                            >
                              Quote Currency
                            </label>
                            <div className="input-group">
                              <input
                                type="text"
                                className="form-control"
                                name="quote_currency"
                                id="quote_currency"
                                defaultValue={data?.quote_currency}
                              />
                            </div>
                            {errorMessage?.quote_currency && (
                              <span className="text-danger pt-2">
                                {errorMessage?.quote_currency?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="image" className="required">
                          Image
                        </label>
                        <input
                          type="file"
                          accept=".jpg,.jpeg,.png"
                          className="form-control"
                          name="image"
                          onChange={handleImage}
                          required=""
                          id="image"
                        />
                        <small className="mt-2  ">
                          Supported files: <b>jpeg, jpg, png.</b> Image will be
                          resized into 400x400 px{" "}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card-footer">
                  <button
                    type="submit"
                    ref={refSubmitDis}
                    className="btn btn-primary w-100 h-45"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
};
export default ForexEdit;
